import React from "react";
import { Box } from "@mui/material";

import Typography from "components/basic/typography";

export const SectionLabel: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
    {children}
  </Typography>
);

interface FieldProps {
  label: string;
  children: React.ReactNode;
}

// A labelled form section: bold label with the control spaced beneath it.
const Field: React.FC<FieldProps> = ({ label, children }) => (
  <Box>
    <SectionLabel>{label}</SectionLabel>
    <Box sx={{ mt: 0.5 }}>{children}</Box>
  </Box>
);

export default Field;
